// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from '@firebase/firestore';
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyB8LP04Dw67M_vtIn0_oMrrEcw0x38KqJg",
  authDomain: "ktofive.com",
  projectId: "ktofive-8d587",
  storageBucket: "ktofive-8d587.appspot.com",
  messagingSenderId: "62543377949",
  appId: "1:62543377949:web:64936a51e5eb05a081f8f4",
  measurementId: "G-0XS8CMWWZH"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);